import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { pickBy } from 'lodash';
import { withRouter } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { Field, reduxForm } from 'redux-form';
import {
  FormControlLabel,
  Checkbox,
  Grid,
  ExpansionPanel,
  ExpansionPanelDetails,
  Button,
} from 'material-ui';
import CheckBoxIcon from 'material-ui-icons/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from 'material-ui-icons/KeyboardArrowUp';
import ClearIcon from 'material-ui-icons/Clear';
import {
  DropDownMenu,
  listingTypes,
  projectTimings,
  sectors,
  areas,
  Loading,
  MultiSelect,
  offerTypes,
} from 'entoro-shared';
import OfferCard from './OfferCard';
import { OfferNav } from './OfferNav';
import { OfferNavListingType } from './OfferNavListingType';
import OfferBlankState from './OfferBlankState';
import InvestmentTable from './InvestmentTable';
import SearchOffers from './SearchOffers';

const Filters = ({
  changeFilters,
  location,
  filteredOptionsData,
  showClear,
}) => {
  const params = new URLSearchParams(location.search);
  const advanced = Boolean(params.get('advanced'));

  if (filteredOptionsData.loading) return null;

  const {
    sectors: filteredSectors,
    areas: filteredAreas,
    listingTypes: filteredListingTypes,
  } = filteredOptionsData.filteredOptions;

  const filteredSectorOptions = sectors.options.filter(({ value }) =>
    filteredSectors.includes(value)
  );

  const filteredAreaOptions = areas.options.filter(({ value }) =>
    filteredAreas.includes(value)
  );

  const filteredListingTypeOptions = listingTypes.options.filter(({ value }) =>
    filteredListingTypes.includes(value)
  );

  return (
    <Fragment>
      <Grid container spacing={8} className='offers-search-bar-small'>
        <div className='div-block-copy'>
          <h1 className='_1st-header'>Explore All Offers</h1>
        </div>
        <Grid item>
          <Field
            component={SearchOffers}
            placeholder='Search Offers'
            className='search-offers'
            name='search'
            onKeyDown={({ keyCode, target }) =>
              keyCode === 13 && changeFilters({ search: target.value })
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={8} className='offers-search-bar'>
        <OfferNav />
        <Grid item xs={12} sm={2} style={{ paddingTop: 10 }}>
          <FormControlLabel
            control={
              <Checkbox
                onChange={() => changeFilters({ advanced: !advanced })}
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon />}
                checked={advanced}
              />
            }
            className='advanced-label noselect'
            label='Advanced Filters'
          />
        </Grid>
        <Grid item>
          <Field
            component={SearchOffers}
            placeholder='Search Offers'
            className='search-offers'
            name='search'
            onKeyDown={({ keyCode, target }) =>
              keyCode === 13 && changeFilters({ search: target.value })
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={8} className='offers-listing-type'>
        <OfferNavListingType />
        <Grid item xs={12} sm={2} style={{ paddingTop: 10 }} />
      </Grid>
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <ExpansionPanel
            expanded={advanced}
            style={{ boxShadow: 'none', marginBottom: 0 }}
            CollapseProps={{
              style: advanced
                ? { overflow: 'visible' }
                : { opacity: 'none', visibility: 'hidden' },
            }}
          >
            <ExpansionPanelDetails style={{ padding: 0 }}>
              <Grid container spacing={8}>
                <Grid item xs={12} sm={5} className='project-timing'>
                  <Field
                    label='Listing Type'
                    component={DropDownMenu}
                    name='listingType'
                    options={filteredListingTypeOptions}
                    onChange={(el, val) => changeFilters({ listingType: val })}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Field
                    component={MultiSelect}
                    name='sector'
                    label='Sectors'
                    options={filteredSectorOptions}
                    groups={sectors.groups}
                    onChange={(e, val) => {
                      changeFilters({
                        sector: encodeURIComponent(JSON.stringify(val)),
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Field
                    component={MultiSelect}
                    name='area'
                    label='Areas of Interest'
                    options={filteredAreaOptions}
                    onChange={(e, val) => {
                      changeFilters({
                        area: encodeURIComponent(JSON.stringify(val)),
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={2} className='project-timing'>
                  <Field
                    label='Project Timing'
                    component={DropDownMenu}
                    name='timing'
                    options={projectTimings.options}
                    onChange={(el, val) => changeFilters({ timing: val })}
                  />
                </Grid>
                <Grid item xs={12} sm={2} className='project-timing'>
                  <Field
                    label='Type Of Offer'
                    component={DropDownMenu}
                    name='typeOfOffer'
                    options={offerTypes.options}
                    onChange={(el, val) => changeFilters({ typeOfOffer: val })}
                  />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <Grid container spacing={0} className='clear-button-container'>
            <Button
              style={!showClear ? { visibility: 'hidden' } : {}}
              disableRipple
              disableFocusRipple
              className='clear-button'
              onClick={() => {
                changeFilters({
                  search: null,
                  timing: null,
                  sector: null,
                  area: null,
                  listingType: null,
                  typeOfOffer: null,
                });
              }}
            >
              Clear Filters
              <ClearIcon />
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

Filters.propTypes = {
  changeFilters: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  filteredOptionsData: PropTypes.object.isRequired,
  showClear: PropTypes.bool.isRequired,
};

const OfferGridFilter = reduxForm({
  form: 'filterBarForm',
  enableReinitialize: true,
})(({ handleSubmit, changeFilters, location, filteredOptionsData }) => (
  <form
    className='filter-bar-form'
    onSubmit={handleSubmit(
      ({ area, sector, listingType, search, timing, typeOfOffer }) =>
        changeFilters({
          area,
          sector,
          listingType,
          search,
          timing,
          typeOfOffer,
        })
    )}
  >
    <Filters
      location={location}
      handleSubmit={handleSubmit}
      changeFilters={changeFilters}
      filteredOptionsData={filteredOptionsData}
      showClear={Boolean(
        location.search &&
          location.search !== '?' &&
          !location.search.includes('?advanced=true')
      )}
    />
  </form>
));

const OfferGrid = ({
  filteredData,
  filter,
  totalPages,
  pageIndex,
  changePage,
  queryName,
  history,
  search,
  timing,
  typeOfOffer,
  location,
  loading,
  filteredOptionsData,
}) => {
  const params = new URLSearchParams(location.search);
  const advanced = Boolean(params.get('advanced'));
  const investments = queryName === 'allUserInvestments';
  const isFiltered = location.search.includes('filter=');
  const onFilterChange = (newValues) => {
    const { listingType, sector, area } = filter;

    let data = {
      listingType,
      sector,
      area,
      search,
      advanced,
      timing,
      typeOfOffer,
    };

    if (data.area) {
      data.area = encodeURIComponent(JSON.stringify(area));
    }

    if (data.sector) {
      data.sector = encodeURIComponent(JSON.stringify(sector));
    }

    data = {
      ...data,
      ...newValues,
    };

    const offerSearch = `?${new URLSearchParams(pickBy(data)).toString()}`;

    history.push({
      search: offerSearch,
      pathname: location.pathname,
    });
  };

  return (
    <div className='section'>
      <div className='max-width-div w-clearfix'>
        <div className='div-block-copy'>
          <h1 className='_1st-header'>Explore All Offers</h1>
        </div>
        {!isFiltered && (
          <OfferGridFilter
            filteredOptionsData={filteredOptionsData}
            location={location}
            changeFilters={onFilterChange}
            initialValues={{ ...filter, search, timing, typeOfOffer }}
          />
        )}
        <div className='div-block-5'>
          {loading && <Loading />}
          {!loading && investments ? (
            <InvestmentTable investments={filteredData} />
          ) : null}
          {!loading && !investments && filteredData.length
            ? filteredData.map((offer) => (
                // eslint-disable-next-line no-underscore-dangle
                <OfferCard key={offer._id} offer={offer} />
              ))
            : null}
          {!loading && !investments && !filteredData.length ? (
            <OfferBlankState fullHeight={false} />
          ) : null}
        </div>
        <div className='full-line bottom' />
      </div>
      <div className='pagenation-container'>
        <ReactPaginate
          onPageChange={changePage}
          pageCount={totalPages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          initialPage={pageIndex}
          disableInitialCallback
          previousLabel={null}
          nextLabel={null}
          containerClassName='pagination-container paginate-list'
          pageLinkClassName='square-paginiation'
          pageClassName='pagination-container'
          activeLinkClassName='square-paginiation active'
        />
      </div>
    </div>
  );
};

OfferGrid.propTypes = {
  filteredData: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  filter: PropTypes.object,
  search: PropTypes.string,
  timing: PropTypes.string,
  typeOfOffer: PropTypes.string,
  queryName: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  filteredOptionsData: PropTypes.object.isRequired,
};

OfferGrid.defaultProps = {
  filter: null,
  search: null,
  timing: null,
  typeOfOffer: null,
};

export default withRouter(OfferGrid);



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferGrid.js